var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUserProfile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "User_Profile",
    "data-name": "User Profile",
    transform: "translate(0 -0.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Base",
    transform: "translate(0 0.001)",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20,0A20,20,0,1,1,0,20,20,20,0,0,1,20,0Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 20 4 C 15.72624015808105 4 11.70829010009766 5.664291381835938 8.686290740966797 8.686290740966797 C 5.664291381835938 11.70829010009766 4 15.72624015808105 4 20 C 4 24.27375984191895 5.664291381835938 28.29170989990234 8.686290740966797 31.3137092590332 C 11.70829010009766 34.33570861816406 15.72624015808105 36 20 36 C 24.27375984191895 36 28.29170989990234 34.33570861816406 31.3137092590332 31.3137092590332 C 34.33570861816406 28.29170989990234 36 24.27375984191895 36 20 C 36 15.72624015808105 34.33570861816406 11.70829010009766 31.3137092590332 8.686290740966797 C 28.29170989990234 5.664291381835938 24.27375984191895 4 20 4 M 20 0 C 31.04570007324219 0 40 8.954299926757812 40 20 C 40 31.04570007324219 31.04570007324219 40 20 40 C 8.954299926757812 40 0 31.04570007324219 0 20 C 0 8.954299926757812 8.954299926757812 0 20 0 Z",
    stroke: "none",
    fill: "#e2bee0"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1763",
    "data-name": "Path 1763",
    d: "M16,0A16,16,0,1,0,32,16,16,16,0,0,0,16,0Zm0,4.784a5.292,5.292,0,1,1-5.292,5.292A5.293,5.293,0,0,1,16,4.785Zm0,23.033A11.743,11.743,0,0,1,8.35,25a2.255,2.255,0,0,1-.791-1.714,5.337,5.337,0,0,1,5.363-5.336h6.158a5.33,5.33,0,0,1,5.355,5.336A2.25,2.25,0,0,1,23.645,25,11.739,11.739,0,0,1,16,27.818Z",
    transform: "translate(4 3.999)",
    fill: "#ba43b1"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserProfile);
export default __webpack_public_path__ + "static/media/userProfile.ad1ffe95ffdaacb1e576bcf6f7a42005.svg";
export { ForwardRef as ReactComponent };